import { render, staticRenderFns } from "./AvailabilityPage.vue?vue&type=template&id=23130af0"
import script from "./AvailabilityPage.vue?vue&type=script&lang=js"
export * from "./AvailabilityPage.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityPage.vue?vue&type=style&index=0&id=23130af0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports